import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onEach(_this__u8e3s4, action) {
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (onEach$$inlined$unsafeTransform$1())(_this__u8e3s4, action);
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.v1h_1 = function_0;
      }
      *r1d(value, $completion) {
        return yield* this.v1h_1(value, $completion);
      }
      i5() {
        return this.v1h_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var onEach$o$collect$slambdaClass;
function onEach$o$collect$slambda() {
  if (onEach$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $action) {
        this.w1h_1 = $$this$unsafeFlow;
        this.x1h_1 = $action;
      }
      *y1h(value, $completion) {
        var $this$transform = this.w1h_1;
        yield* this.x1h_1(value, $completion);
        yield* $this$transform.r1d(value, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.y1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    onEach$o$collect$slambdaClass = $;
  }
  return onEach$o$collect$slambdaClass;
}
function onEach$o$collect$slambda_0($$this$unsafeFlow, $action) {
  var i = new (onEach$o$collect$slambda())($$this$unsafeFlow, $action);
  var l = (value, $completion) => i.y1h(value, $completion);
  l.$arity = 1;
  return l;
}
var onEach$$inlined$unsafeTransform$1Class;
function onEach$$inlined$unsafeTransform$1() {
  if (onEach$$inlined$unsafeTransform$1Class === VOID) {
    class $ {
      constructor($this, $action) {
        this.z1h_1 = $this;
        this.a1i_1 = $action;
      }
      *q1d(collector, $completion) {
        var tmp = onEach$o$collect$slambda_0(collector, this.a1i_1);
        yield* this.z1h_1.z1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      z1c(collector, $completion) {
        return this.q1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    onEach$$inlined$unsafeTransform$1Class = $;
  }
  return onEach$$inlined$unsafeTransform$1Class;
}
//region block: exports
export {
  onEach as onEach13yrgg7fxnyl6,
};
//endregion

//# sourceMappingURL=Transform.mjs.map
